import axios from "./axios";

export async function deleteCase(payload) {
  return axios
    .delete(`/cases/` + payload?.id)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

export async function deleteCaseItem(payload) {
  return axios
    .delete(`/cases/${payload.case_id}/items/${payload.id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
}

export async function createCase(payload) {
  return axios
    .post(`/cases/`, { case: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

export async function createCaseItem(payload) {
  return axios
    .post(`/cases/${payload.case_id}/items`, { case_item: payload })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
}

export async function updateCaseItem(caseId, itemId, payload) {
  return axios
    .put(`/cases/${caseId}/items/${itemId}`, { case_item: payload })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
}

export async function postCaseSendEmailEmployee(payload) {
  return axios
    .post(`/cases/${payload.id}/send_email_employee`, payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
}

export async function updateCase(payload) {
  return axios
    .put(`/cases/` + payload.id, { case: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      // return error.response.data
      if (error.status !== 200) return error;
      else return error.response;
    });
}

/**
 * Load a single case. Pass `fields` to limit JSON (omit `items` / `last_item` and use fetchCaseItems).
 * @param {string|number} caseId
 * @param {{ fields?: string }} [options]
 */
export async function fetchCase(caseId, options = {}) {
  const params = {};
  if (options?.fields) params.fields = options.fields;

  return axios
    .get(`/cases/${caseId}`, { params })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

/** Case header + form payload without embedded timeline items (items: GET /cases/:id/items). */
export const CASE_DETAIL_FIELDS_WITHOUT_ITEMS =
  "id,case_number,title,status,case_type,user_assigned,user_responsible,description,date,fields,customer,contact,project,report,service_agreement,order,note,priority,due_date,tag_definitions,created_at,updated_at";

export async function fetchCaseItems(caseId, controller = {}) {
  const { page = 1, per_page = 25, sortBy = "created_at", sort = "desc" } = controller;
  const params = {
    page,
    per_page,
    sortBy,
    sort,
  };

  return axios({ method: "get", url: `/cases/${caseId}/items`, params })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error?.response?.data || { data: [], totalCount: 0, currentCount: 0 };
    });
}

export async function fetchCasesStats() {
  return axios({ method: "get", url: "/cases/stats" })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

export async function fetchCases(controller) {
  let { filters, sort, sortBy, page, query, view, per_page, fields } =
    controller;

  const params = {
    query: query,
    page: page,
    per_page: per_page,
    sortBy: sortBy,
    sort: sort,
    filters: filters,
    view: view,
    fields: fields,
  };

  return axios({ method: "get", url: "/cases/", params: params })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

export async function fetchCaseTypes() {
  return axios({ method: "get", url: "/cases/types" })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

export async function createCaseFromCall(payload) {
  return axios
    .post(`/cases/create_from_call`, payload)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

export const linkCallToCase = (payload) =>
  axios
    .post(`/cases/link_to_case`, payload)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });

export const processCallWithoutCase = (payload) =>
  axios
    .post(`/cases/process_without_case`, payload)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });

/**
 * Search across customers, reports, projects, contacts for slash command (/63183).
 * Returns combined results with module type and displayTitle.
 */
export async function searchSlashModules(query, customerId = null) {
  if (!query || typeof query !== "string") return [];
  const q = query.trim();
  if (!q) return [];

  const params = {
    query: q,
    page: 1,
    per_page: 5,
    sortBy: "updated_at",
    sort: "desc",
    fields: "id,displayTitle,name,customer",
  };

  const endpoints = [
    { url: "/customers/", params, module: "customer", labelKey: "Customer" },
    { url: "/service/reports/", params: { ...params, fields: "id,displayTitle,report_number,customer" }, module: "report", labelKey: "Report" },
    { url: "/projects/", params: { ...params, fields: "id,displayTitle,customer" }, module: "project", labelKey: "Project" },
    { url: "/contacts/", params: { ...params, filters: customerId ? [{ name: "CUSTOMER", value: customerId }] : null }, module: "contact", labelKey: "Contact" },
  ];

  const results = await Promise.allSettled(
    endpoints.map(({ url, params: p, module, labelKey }) =>
      axios.get(url, { params: p }).then((res) => {
        const data = res?.data?.data || res?.data || [];
        const list = Array.isArray(data) ? data : [];
        return list.map((row) => ({
          id: row.id,
          module,
          labelKey,
          displayTitle: row?.displayTitle ?? row?.name ?? row?.report_number ?? `#${row.id}`,
          object: row,
        }));
      })
    )
  );

  const combined = [];
  results.forEach((r, i) => {
    if (r.status === "fulfilled" && Array.isArray(r.value)) {
      combined.push(...r.value);
    }
  });

  return combined;
}
